import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useColorMode, useToast } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { TOKEN } from '../api/axiosInstance';
import '../styles/navbar.css';
import TrialToastContent from '../components/TrialToastContent'; // adjust path if needed

const PAYMENT_ROUTES = ['/payment', '/upgradeaccount'];

function TrialToast() {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const { colorMode } = useColorMode();
  const [toastTrialMessage, setToastTrialMessage] = useState(undefined);
  const { user } = useSelector((state) => state.user);
  const isLoggedIn = (((user && Object.keys(user).length > 2) || window.localStorage.getItem(TOKEN)) ? (true):(false));
  const isPaymentRoute = PAYMENT_ROUTES.includes(location.pathname);
  const previousColorMode = useRef(colorMode);

  useEffect(() => {
    // Hide on payment/upgrade screens — user is already upgrading. Re-appears on other routes.
    if (isPaymentRoute) {
      toast.close("trial_toast");
      setToastTrialMessage(undefined);
      return;
    }

    if (
      isLoggedIn === true &&
      user?.user_id !== undefined &&
      user?.has_paid === 0 &&
      user?.created_at
    ) {
      const rawTimestamp = user.created_at.replace(' ', 'T') + 'Z'; // → "2025-06-11T00:51:36Z"
      const trialStart = new Date(rawTimestamp); // now parsed as UTC
      const expiryDate = new Date(trialStart.getTime() + 5 * 24 * 60 * 60 * 1000);

      const formattedExpiry = expiryDate.toLocaleString(navigator.language || 'en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
      setToastTrialMessage({ message: "You're on a 5 Day Free Trial", expiry: formattedExpiry });
    } else {
      // Not logged in, or user has paid — dismiss the toast.
      toast.close("trial_toast");
      setToastTrialMessage(undefined);
    }
  }, [isLoggedIn, user, isPaymentRoute, toast]);

  const [isCollapsed, setIsCollapsed] = useState(false);
  const previousIsCollapsed = useRef(isCollapsed);

  
  useEffect(() => {
    if (toastTrialMessage) {
      const renderToast = () => (
        <TrialToastContent
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          colorMode={colorMode}
          navigate={navigate}
          toastMessage={toastTrialMessage}
        />
      );
  
      if (toast.isActive("trial_toast") && (previousColorMode.current !== colorMode || previousIsCollapsed.current !== isCollapsed)) {
        toast.update("trial_toast", {
          render: renderToast,
          isClosable: false,
        });
      } else if (!toast.isActive("trial_toast")) {
        toast({
          id: "trial_toast",
          variant: 'solid',
          status: 'info',
          duration: null,
          render: renderToast,
          isClosable: false,
        });
      }
  
      previousColorMode.current = colorMode;
      previousIsCollapsed.current  = isCollapsed;
    }
  }, [
    toastTrialMessage,
    toast,
    isCollapsed,
    colorMode,
    navigate, // include this too
    setIsCollapsed, // optional if stable from context or same scope
  ]);

  return null;
}



export default TrialToast;